App.watch = function(el, handler) {
  $(document).on("propertychange keyup input paste", el, function(e) {
    handler($(this));
  });
}
